import pDefer from "p-defer";
import { defineStore, type Store } from "pinia";

export interface State {
	amount: number
}

export interface Actions {
	set(amount: number): void
}

export interface Getters {
	formattedAmount(): string
}

export type FundsStore = Store<string, State, Getters, Actions>;

const STORE_NAME = "funds-store";

const fundsStore = pDefer<FundsStore>();

export function defineFundsStore(amount: number): FundsStore {
	const store = defineStore(STORE_NAME, {
		state: (): State => ({
			amount,
		}),
		actions: {
			set(amount: number) {
				this.amount = amount;
			},
		},
		getters: {
			formattedAmount(): string {
				return new Intl.NumberFormat().format(this.amount);
			},
		},
	})();

	fundsStore.resolve(store);
	return store;
}

export function useFundsStore(): Promise<FundsStore> {
	return fundsStore.promise;
}
